import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { ContractService } from '../../_services';
import { ContractBase } from "./contract.base";
import { IIdNameGeneric } from '../../_entities';
import * as moment from 'moment';
import { StringTool } from "../../core/tools/index";

@Component({
	selector: 'contract-rent-deduction',
	template: require('./contract-rent-deduction.component.html'),
	encapsulation: ViewEncapsulation.None
})
export class ContractRentDeductionComponent extends ContractBase implements OnInit {

	get rentAndCharges(): any {
		const contract: any = this.contract;
		return contract != null ? contract.rentAndCharges : null;
	}

	constructor(
		protected readonly contractService: ContractService) {
		super(contractService);


		Array.from(Array(15).keys()).map(i => 2014 + i).forEach(year =>
			Array.from(Array(12).keys()).map(i => 1 + i).forEach(month => {
				this.months.push({
						id: `${year}-${StringTool.padZero(month, 2)}-01`,
						name: moment(`${year}-${StringTool.padZero(month, 2)}-01`, 'YYYY-MM-DD').format("MMM-YY")
					});
				}
			));

	}

	ngOnInit(): void {
	}

	ngOnDestroy(): void {
	}

	yesNoOptions = [{ id: false, name: 'No' }, { id: true, name: 'Yes' }];


	months: IIdNameGeneric<string>[] = [];


	get rentFreeValue(): number {
		if (this.rentAndCharges &&
			this.rentAndCharges.yearlyRent &&
			this.rentAndCharges.yearlyRent !== 0 &&
			this.rentAndCharges.rentFreePeriod &&
			this.rentAndCharges.rentFreePeriod !== 0) {
			return (this.rentAndCharges.yearlyRent / 12) * this.rentAndCharges.rentFreePeriod;
		}

		return null;
	}


}




// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/angular2-router-loader/src!./TypeScript/shared/contract/contract-rent-deduction.component.ts